export const environment = {
  production: false,
  empresa: {
    name: 'Restaurante La Nopalera',
    phone: '4416903299',
    whatsapp: '+5214416903299',
    address: 'Agustín Melgar 75, Centro, 76650 Ezequiel Montes, Qro.',
  },

/*   firebaseConfig : {
    apiKey: "AIzaSyB5Va-2VekC9c_3rGB1ndR3eDgoPMiWatA",
    authDomain: "nopalera-652ce.firebaseapp.com",
    databaseURL: "https://nopalera-652ce.firebaseio.com",
    projectId: "nopalera-652ce",
    storageBucket: "nopalera-652ce.appspot.com",
    messagingSenderId: "93771578894",
    appId: "1:93771578894:web:133f864ff7e1ed47a2865f",
    measurementId: "G-K3MYX5BMGN"
  } */

  firebaseConfig : {
    apiKey: "AIzaSyDdnAcZc_UrsS3i9n0kg_VdEI7aYosSaDM",
    authDomain: "lanopalera-restaurante.firebaseapp.com",
    databaseURL: "https://lanopalera-restaurante.firebaseio.com",
    projectId: "lanopalera-restaurante",
    storageBucket: "lanopalera-restaurante.appspot.com",
    messagingSenderId: "136567441934",
    appId: "1:136567441934:web:de9e4282860d4d0eeeca5f",
    measurementId: "G-14QGF30R7P"
  }
/*   firebaseConfig : {
    apiKey: "AIzaSyDdnAcZc_UrsS3i9n0kg_VdEI7aYosSaDM",
    authDomain: "lanopalera-restaurante.firebaseapp.com",
    databaseURL: "https://lanopalera-restaurante.firebaseio.com",
    projectId: "lanopalera-restaurante",
    storageBucket: "lanopalera-restaurante.appspot.com",
    messagingSenderId: "136567441934",
    appId: "1:136567441934:web:de9e4282860d4d0eeeca5f",
    measurementId: "G-14QGF30R7P"
  } */
};

